export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Ecommerce.vue'),
    meta: {
      resource: 'Dashboard',
      action: 'read',
    },
  }
]
